import React, { useEffect, useState } from "react";
import {
  AdminSearchBrands,
  ViewAdminBrands,
  getCategories,
  deleteCategory,
  checkCategoryProducts,
} from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const Categories = () => {
  const currentUser = useRecoilValue(userState);
  const [brandData, setBrandData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [size, setSize] = useState();
  const [categories, setCategories] = useState([]);
  const [temp, setTemp] = useState([]);
  const [restart, setRestart] = useState(false);
  const [deleteConfirmed, confirmDelete] = useState(null);
  const [categoryID, setCategoryID] = useState(""); // handles the real deletion
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [showDestinationModal, setShowDestinationModal] = useState(false);
  const [showSimpleConfirm, setShowSimpleConfirm] = useState(false);
  const [destinationCategoryId, setDestinationCategoryId] = useState("");
  const [productCheck, setProductCheck] = useState(null);

  const handleConfirm = async () => {
    let data = {
      categoryId: categoryID,
      destinationCategoryId: destinationCategoryId || undefined,
    };
    try {
      console.log(data);
      const deleteResponse = await deleteCategory(data);
      console.log(deleteResponse);

      // Close modals
      confirmDelete(null);
      setShowSimpleConfirm(false);
      setShowDestinationModal(false);

      // Show success popup with details
      if (deleteResponse?.data?.message) {
        const movedProducts = deleteResponse.data.movedProducts || 0;
        const movedBrands = deleteResponse.data.movedBrands || 0;

        let message = deleteResponse.data.message;
        if (movedProducts > 0 || movedBrands > 0) {
          const parts = [];
          if (movedProducts > 0) parts.push(`${movedProducts} product(s)`);
          if (movedBrands > 0) parts.push(`${movedBrands} brand(s)`);
         const destCategory = deleteResponse.data.destinationCategory || "Uncategorized";
            message = `Category deleted successfully. ${parts.join(' and ')} moved to "${destCategory}".`;
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: message,
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error) {
      console.error(error);
      confirmDelete(null);
      setShowSimpleConfirm(false);
      setShowDestinationModal(false);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to delete category",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  // New delete click handler with product check
  const handleDeleteClick = async (category) => {
    // Prevent deleting Uncategorized
    if (category.categoryName === "Uncategorized") {
      Swal.fire({
        icon: "warning",
        title: "Cannot Delete",
        text: "The 'Uncategorized' category cannot be deleted as it's used as a fallback.",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    setCategoryToDelete(category);
    setCategoryID(category.ID);

    // Check if category has products
    try {
      const checkResponse = await checkCategoryProducts(category.ID);
      console.log("Product check:", checkResponse.data);
      setProductCheck(checkResponse.data);

      // Flow 1: No products → simple confirmation
      if (!checkResponse.data.hasProducts && !checkResponse.data.hasBrands) {
        setShowSimpleConfirm(true);
      }
      // Flow 2: Has products → show destination selector
      else {
        setShowDestinationModal(true);
      }
    } catch (error) {
      console.error("Error checking category:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to check category. Please try again.",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  // Destination Modal Component
  const DestinationModal = ({ show, productCheck, onConfirm, onCancel }) => {
    const [selection, setSelection] = useState("uncategorized");
    const [selectedCategoryId, setSelectedCategoryId] = useState("");

    if (!show || !productCheck) return null;

    return (
      <>
        <div className="modal-backdrop fade show"></div>
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h5 className="modal-title" style={{ color: "#bb2d5e" }}>
                  Category Has Products
                </h5>
                <button className="btn-close" onClick={onCancel} />
              </div>

              <div className="modal-body">
                <p>
                  This category has{" "}
                  <strong>{productCheck.productCount} product(s)</strong>
                  {productCheck.brandCount > 0 && ` and `}
                  {productCheck.brandCount > 0 && (
                    <strong>{productCheck.brandCount} brand(s)</strong>
                  )}
                  .
                </p>
                <p className="mt-2">Where should they be moved?</p>

                <div className="form-check mb-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="moveToUncategorized"
                    checked={selection === "uncategorized"}
                    onChange={() => setSelection("uncategorized")}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="moveToUncategorized"
                  >
                    Move to "Uncategorized"
                  </label>
                </div>

                <div className="form-check mb-3">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="moveToCustom"
                    checked={selection === "custom"}
                    onChange={() => setSelection("custom")}
                  />
                  <label className="form-check-label" htmlFor="moveToCustom">
                    Select a different category
                  </label>
                </div>

                {selection === "custom" && (
                  <select
                    className="form-select"
                    value={selectedCategoryId}
                    onChange={(e) => setSelectedCategoryId(e.target.value)}
                  >
                    <option value="">-- Select Category --</option>
                    {categories
                      .filter(
                        (cat) =>
                          cat.ID !== categoryToDelete?.ID &&
                          cat.categoryName !== "Uncategorized"
                      )
                      .map((cat) => (
                        <option key={cat.ID} value={cat.ID}>
                          {cat.categoryName}
                        </option>
                      ))}
                  </select>
                )}
              </div>

              <div className="modal-footer" style={{ borderTop: "none" }}>
                <button className="btn btn-secondary" onClick={onCancel}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setDestinationCategoryId(
                      selection === "custom" ? selectedCategoryId : ""
                    );
                    onConfirm();
                  }}
                  disabled={selection === "custom" && !selectedCategoryId}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  // Confirm delete component...
  const ConfirmModal = ({
    show,
    title = "Confirm Delete",
    message = "Are you sure you want to delete this category? Products and brands will be moved to 'Uncategorized'.",
    onConfirm,
    onCancel,
  }) => {
    if (!show) return null;

    return (
      <>
        {/* Backdrop */}
        <div className="modal-backdrop fade show"></div>

        {/* Modal */}
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h5 className="modal-title" style={{ color: "#bb2d5e" }}>
                  {title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onCancel}
                />
              </div>

              <div className="modal-body text-center">
                <p className="mb-0">{message}</p>
              </div>

              <div className="modal-footer" style={{ borderTop: "none" }}>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onCancel}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn text-white"
                  style={{ backgroundColor: "#bb2d5e" }}
                  onClick={onConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const itemsPerPage = 5;

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = categories?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(categories?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % categories?.length;
    setItemOffset(newOffset);
  };

  const ViewAllBrands = async () => {
    try {
      const response = await ViewAdminBrands(
        currentUser.data.info.id,
        currentUser.data.token
      );
      setBrandData(response.data);
    } catch (err) {
      return err;
    }
  };

  const searchBrands = async () => {
    try {
      // const response = await fetch(
      //   // `http://localhost:7045/api/v1/brands/search?name=${searchTerm}`
      //   `https://argoneworldadminbackend.findfood.ng/api/v1/brands/search?name=${searchTerm}`
      // );

      const response = await AdminSearchBrands(
        searchTerm,
        currentUser.data.token
      );
      const data = await response.json();
      setBrandData(data.data);
    } catch (err) {
      console.error("Error searching for brands:", err);
    }
  };

  useEffect(() => {
    GetAllCategories();
  }, [restart]);
  const GetAllCategories = async () => {
    try {
      const response = await getCategories();
      console.log(response.categories);
      setCategories(response.categories);
      setTemp(response.categories);
    } catch (err) {
      return err;
    }
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const onSearch = async () => {
    try {
      const response = await getCategories(searchTerm, size);
      setCategories(response.categories);
      setTemp(response.categories);
    } catch (err) {
      return err;
    }
  };
  const onSelectionChange = async (e) => {
    const { name, value } = e.target;
    // setTemp({});
    if (value !== "all" && temp.length > parseInt(value)) {
      // setSize(parseInt(value));
      // try {
      //   const response = await getCategories(searchTerm, parseInt(value));
      //   setCategories(response.categories);
      //
      // } catch (err) {
      //   return err;
      // }
      setCategories(categories.slice(parseInt(value)));
    } else {
      setCategories(temp);
    }
  };
  return (
    // <section class="content-main">
    //   <div class="content-header">
    //     <div>
    //       <h2 class="content-title card-title">Categories</h2>
    //       <p>Add, edit or delete a category</p>
    //     </div>
    //     <div>
    //       <Link to="/category-form" class="btn btn-primary">
    //         <i class="text-muted material-icons md-post_add"></i>Add New Category
    //       </Link>
    //     </div>
    //   </div>
    //   <div class="card mb-4">
    //     <header class="card-header">
    //       <div class="row gx-3">
    //         <div class="col-lg-4 mb-lg-0 mb-15 me-auto">
    //           <div>All Brands</div>
    //           {/* <form onSubmit={handleSearchSubmit}>
    //             <input
    //               type="text"
    //               placeholder="Search..."
    //               className="form-control"
    //               value={searchTerm}
    //               onChange={handleSearchChange}
    //             />
    //           </form> */}
    //         </div>
    //         {/* <div class="col-lg-2 col-6">
    //           <div class="custom_select">
    //             <select class="form-select select-nice">
    //               <option selected>Categories</option>
    //               <option>Technology</option>
    //               <option>Fashion</option>
    //               <option>Home Decor</option>
    //               <option>Healthy</option>
    //               <option>Travel</option>
    //               <option>Auto-car</option>
    //             </select>
    //           </div>
    //         </div>
    //         <div class="col-lg-2 col-6">
    //           <input type="date" class="form-control" name="" />
    //         </div> */}
    //       </div>
    //     </header>

    //     <div class="card-body">
    //       <div class="row gx-3">
    //         {brandData?.length >= 1 ? (
    //           <>
    //             {brandData?.map((props) => (
    //               <div class="col-xl-2 col-lg-3 col-md-4 col-6" key={props.id}>
    //                 <figure class="card border-1">
    //                   <div class="card-header bg-white text-center">
    //                     <img
    //                       style={{
    //                         height: "70px",
    //                         width: "100%",
    //                         objectFit: "cover",
    //                       }}
    //                       // src={`http://localhost:7045/uploads/${props?.image[0]?.img}`}
    //                       src={`https://argoneworldadminbackend.findfood.ng/uploads/${props?.image[0]?.img}`}
    //                       class="img-fluid"
    //                       alt="Logo"
    //                     />
    //                   </div>
    //                   <figcaption class="card-body text-center">
    //                     <h6 class="card-title m-0">{props.name}</h6>
    //                     <a href="#"> {props?.product?.length} items </a>
    //                   </figcaption>
    //                 </figure>
    //               </div>
    //             ))}
    //           </>
    //         ) : (
    //           <div>No brand found</div>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Categories</h2>
          <p>Manage categories, subcategories, and brands.</p>
        </div>
        <div>
          <Link to="/category-form" class="btn btn-primary">
            <i class="text-muted material-icons md-post_add"></i>Add New
            Category
          </Link>
        </div>
      </div>
      <div class="card mb-4">
        <header class="card-header">
          <div class="row gx-3">
            <div class="col-lg-4 col-md-6 me-auto">
              <input
                type="text"
                placeholder="Search by category name, description"
                class="form-control"
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyUp={onSearch}
              />
            </div>
            {/* <div class="col-lg-2 col-6 col-md-3">
            <select class="form-select">
              <option>Status</option>
              <option>Active</option>
              <option>Disabled</option>
              <option>Show all</option>
            </select>
          </div> */}
            <div class="col-lg-2 col-6 col-md-3">
              {/* <select class="form-select" name="selection" onChange={onSelectionChange}>
                <option value="all">All</option>
                <option value="1">Show 5</option>
                <option value="5">Show 5</option>
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="30">Show 30</option>
                <option value="40">Show 40</option>
              </select> */}
            </div>
          </div>
        </header>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">Category Name</th>
                  <th scope="col">Category Id</th>
                  <th scope="col">Created Date</th>
                  <th scope="col">Description</th>
                  <th scope="col" class="text-end">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {categories && categories.length > 0 ? (
                  categories.map((category, i) => (
                    <tr key={"category" + i}>
                      <td>{i + 1}</td>
                      <td>{category.categoryName}</td>
                      <td>{category.ID}</td>
                      <td>
                        {new Date(category.createdDate).toLocaleDateString()}
                      </td>
                      <td>{category.description || "N/A"}</td>
                      <td class="text-end">
                        {/* <div class="dropdown">
                        <a
                          href="#"
                          data-bs-toggle="dropdown"
                          class="btn btn-light rounded btn-sm font-sm"
                        >
                          <i class="material-icons md-more_horiz"></i>
                        </a>
                        <div class="dropdown-menu mb-5">
                          <Link
                            class="dropdown-item"
                            to={`/view-category/${category.ID}`}
                          >
                            View
                          </Link>
                          <Link
                            class="dropdown-item"
                            to={`/update-category/${category.ID}`}>
                            Update
                          </Link>
                          {/* <Link class="dropdown-item text-danger" to="#">
                            Delete
                          </Link>
                        </div>
                      </div> */}
                        <Link
                          class="dropdown-item"
                          to={`/view-category/${category.ID}`}
                        >
                          View
                        </Link>
                        <Link
                          class="dropdown-item"
                          to={`/update-category/${category.ID}`}
                        >
                          Update
                        </Link>

                        <div
                          className="dropdown-item"
                         onClick={() => handleDeleteClick(category)}
                        >
                          Delete
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <div>No order Found</div>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ConfirmModal
        show={deleteConfirmed != null}
        onConfirm={handleConfirm}
        onCancel={() => confirmDelete(null)}
      />

      {/* <div class="pagination-area mt-30 mb-50">
      <nav aria-label="Page navigation example">
      <ReactPaginate
              nextLabel="Next"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link w-auto"
              nextClassName="page-item"
              nextLinkClassName="page-link w-auto"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-start"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
      </nav>
    </div> */}
      {/* Destination Modal */}
      <DestinationModal
        show={showDestinationModal}
        productCheck={productCheck}
        onConfirm={handleConfirm}
        onCancel={() => {
          setShowDestinationModal(false);
          setCategoryToDelete(null);
        }}
      />
      {/* Simple Confirm Modal for empty categories */}
      <ConfirmModal
        show={showSimpleConfirm}
        title="Confirm Delete"
        message="Are you sure you want to delete this category?"
        onConfirm={handleConfirm}
        onCancel={() => {
          setShowSimpleConfirm(false);
          setCategoryToDelete(null);
        }}
      />
      {/* Legacy confirm modal */}
      <ConfirmModal
        show={deleteConfirmed}
        onConfirm={handleConfirm}
        onCancel={() => confirmDelete(null)}
      />
    </section>
  );
};

export default Categories;
